var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationDimRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29235 17.2875C8.90418 16.8966 8.90491 16.2649 9.29446 15.8754L12.4635 12.7063C12.8537 12.3161 12.8541 11.6835 12.4643 11.2929L9.29369 8.11538C8.90484 7.72569 8.90519 7.09466 9.29446 6.70538V6.70538C9.68403 6.31581 10.3157 6.31581 10.7052 6.70538L15.2927 11.2929C15.6833 11.6834 15.6833 12.3166 15.2927 12.7071L10.7095 17.2904C10.318 17.6819 9.68247 17.6804 9.29235 17.2875V17.2875Z",
    fill: "#2F2F2F",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationDimRight);
export default __webpack_public_path__ + "static/media/paginationDim-right.ab6f31d9dfa1503438a42c345dd85045.svg";
export { ForwardRef as ReactComponent };